import { render } from "./TicketPriorityBadge.vue?vue&type=template&id=19d1c7f6"
import script from "./TicketPriorityBadge.vue?vue&type=script&lang=js"
export * from "./TicketPriorityBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__